module.exports = __webpack_public_path__ + "img/about-listed (2).f1d70c5b.jpg";